export default "__VITE_ASSET__BOjYzsD5__"